module.exports = __webpack_public_path__ + "static/media/PrecheckInactive.9020364f.png";